module.exports = __webpack_public_path__ + "img/marker_odp_travaux-0.3a8c96c6.png";